import styled, { keyframes } from 'styled-components'

const animateArrow1 = keyframes`
  0% {
    transform: translateY(-15px);
    opacity: 0
  }

  70%,
  to {
    transform: translateY(0);
    opacity: 1
  }
`
export const StyledReadMoreButton = styled.div`
  text-align: center;
  position: relative;
  cursor: pointer;
  * {
    pointer-events: none;
  }
  &::before {
    content: '';
    position: absolute;
    bottom: 100%;
    height: 200px;
    left: 0;
    background-image: linear-gradient(180deg, #fff0, #fff);
    width: 100%;
  }
  .content {
    cursor: pointer;
    color: #33333380;
    text-align: center;
    margin: 0 5px 20px;
    vertical-align: middle;
    transform: perspective(1px) translateZ(0);
    box-shadow: 0 0 1px transparent;
    position: relative;
    display: inline-block;
    border: none;
    font-size: 19px;
    background: url() no-repeat top;
    background-color: #0000;
    background-size: 26px 17px;
    padding-bottom: 0;
    padding-top: 40px;
  }
  .arrow {
    top: 22px;
    span {
      animation: ${animateArrow1} 1s ease-in-out infinite;
      background: url(/images/double-arrow.png);
      width: 24px;
      height: 24px;
      top: 15px;
      opacity: 1;
      background-size: contain;
      background-repeat: no-repeat;
      display: block;
      right: 0;
      left: 0;
      margin: auto;
      position: absolute;
    }
  }
`
